import ExchangeSummaryPaxs from './ExchangeSummaryPaxs';

export default ExchangeSummaryPaxs;
